import { EntityService } from '../../service/EntityService';


export class InvoiceListService extends EntityService {

  static entity = 'app/invoice-list';

  static downloadXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, {responseType: 'blob'}).then(res => res.data);
  }

  static getPending(invoiceType: number, invoiceListNumber?: string): Promise<any> {
    return this.getList({
      Status: 1,
      InvoiceType: invoiceType,
      InvoiceListNumber: invoiceListNumber,
      MaxResultCount: 1000,
      Sorting: "invoiceListNumber",
      SortType: "DESCEND",
    }).then((res) => {
      return (res.items || []).filter(
        (item) => {
          return  item.status === 1 &&
          !item.hasRelatedInvoice
        }
      );
    });
  }

  static getItems(
    id: string,
    params: {
      SkipCount: number;
      MaxResultCount: number;
      Sorting?: string;
      SortType?: "ASCEND" | "DESCEND";
    },
  ): Promise<any> {
    return this.axios
      .get(`${this.entity}/${id}/items`, { params })
      .then(res => res.data);
  }

  static getPdfUrl(bkDcId: string): string {
    return `${this.baseURL}/${this.entity}/${bkDcId}/download-pdf`;
  }
}
